// extracted by mini-css-extract-plugin
export var activityCardListStatic = "-z+h5";
export var activityCardWrapperStatic = "rQQRY";
export var anchor = "jc2rk";
export var carouselPlaceholder = "xxifp";
export var cta = "uaMUH";
export var description = "nZt46";
export var root = "YSZ5o";
export var title = "_3M+rX";